<script>
	import { Table, DropdownItem } from "sveltestrap";
	import CustomPaginate from "../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../components/Loader/LoaderContainer.svelte";
	import BsLoader from "../../../../components/Loader/BsLoader.svelte";
	import { convert } from "../../../../services/helpers";
	import { loadingStatus, CPOEditData } from "../../../../store/store";
	import { navigate } from "svelte-routing";
	import TableDropdown from "../../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let dataList;
	export let handleStatusChange;
	export let idStatus;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Company Name</th>
				<th>Created On</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each dataList as { id, name, createdAt, status }}
				<tr>
					<td>
						<p>
							<span>
								{name}
							</span>
						</p>
					</td>

					<td>
						{convert(createdAt)}
					</td>

					<td>
						{#if status}
							{#if $loadingStatus && idStatus == id}
								<p>&nbsp; &nbsp; <BsLoader /></p>
							{:else}
								<p class="status-bar status-bar-1">Active</p>
							{/if}
						{:else if $loadingStatus && idStatus == id}
							<p>&nbsp; &nbsp; <BsLoader /></p>
						{:else}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							{#if status}
								<!-- This endpoint needs presetTaskId not returned by fetch api -->
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, false)}
									>Set as Inactive</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, true)}
									>Set as Active</DropdownItem
								>
							{/if}
							<DropdownItem
								on:click={() => {
									CPOEditData.set({
										id: id,
										name: name,
										status: status,
									});
									navigate(
										`/master-data/vehicle-data/cpo-provider/edit/${id}`
									);
								}}>Edit</DropdownItem
							>
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount === 0 || !data.totalCount}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.totalCount || 0} />
</LoaderContainer>
